export default __webpack_public_path__ + "static/media/radio-off.ed405838.svg";